import {VideoType} from "../../definitions/types";
import {MediaType} from "../../definitions/enums";

export class VideoModel {
    private readonly _video: VideoType;

    constructor(public readonly video: VideoType) {
        this._video = video;
    }

    /**
     * @property id
     * @description Returns the Video id.
     * @returns {number}
     */
    public get id(): number {
        return this._video.id;
    }

    /**
     * @property mediaType
     * @description Returns the Video media type.
     * @returns {string}
     */
    public get mediaType(): MediaType {
        return MediaType.Video;
    }

    /**
     * @method type
     * @description Returns the type if available, otherwise returns undefined.
     * @returns {string | undefined}
     */
    public get type(): string | undefined {
        return this._video.type;
    }

    /**
     * @method filename
     * @description Returns the filename if available, otherwise returns undefined.
     * @returns {string | undefined}
     */
    public get filename(): string | undefined {
        return this._video.filename;
    }

    /**
     * @property title
     * @description Returns the title if available, otherwise returns undefined.
     * @returns {string | undefined}
     */
    public get title(): string | undefined {
        return this._video.title;
    }

    /**
     * @property description
     * @description Returns the description if available, otherwise returns undefined.
     * @returns {string | undefined}
     */
    public get description(): string | undefined {
        return this._video.description;
    }

    /**
     * @property width
     * @description Returns the width if available, otherwise returns undefined.
     * @returns {number | undefined}
     */
    public get width(): number | undefined {
        return this._video.width;
    }

    /**
     * @property height
     * @description Returns the height if available, otherwise returns undefined.
     * @returns {number | undefined}
     */
    public get height(): number | undefined {
        return this._video.height;
    }

    /**
     * @property duration
     * @description Returns the duration if available, otherwise returns undefined.
     * @returns {number | undefined}
     */
    public get duration(): number | undefined {
        return this._video.duration;
    }

    /**
     * @method url
     * @description Returns the url if available, otherwise returns undefined.
     * @returns {string | undefined}
     */
    public get url(): string | undefined {
        return this._video.url;
    }

    /**
     * @method thumbnailUrl
     * @description Returns the thumbnailUrl if available, otherwise returns undefined.
     * @returns {string | undefined}
     */
    public get thumbnailUrl(): string | undefined {
        return this._video.thumbnailUrl;
    }
}